const convertToAmount = (number: string | number): string => {
  if (Number.isNaN(+number)) return '0.00';

  return (+number).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export default convertToAmount;
